import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2ResetFilterButton from './VeltCommentsSidebarV2ResetFilterButton/VeltCommentsSidebarV2ResetFilterButton';
var VeltCommentsSidebarV2EmptyPlaceholder = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-empty-placeholder-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2EmptyPlaceholder.ResetFilterButton = VeltCommentsSidebarV2ResetFilterButton;
export default VeltCommentsSidebarV2EmptyPlaceholder;
